import { keyframes } from "@mui/system";

export const motionDurations = {
  quick: 120,
  standard: 180,
  slow: 260,
};

export const motionEasings = {
  entrance: "ease-in",
  emphasized: "cubic-bezier(0.22, 1, 0.36, 1)",
  appleEmphasized: "cubic-bezier(0.32, 0.72, 0, 1)",
};

const dropIn = keyframes({
  "0%": { opacity: 0, transform: "translateY(-6px)" },
  "100%": { opacity: 1, transform: "translateY(0)" },
});

export function dropInAnimation(durationMs = motionDurations.standard): string {
  return `${dropIn} ${durationMs}ms ${motionEasings.entrance}`;
}

interface MotionSxIfEnabledOptions {
  prefersReducedMotion: boolean;
  animation: string;
  willChange?: string;
}

export function motionSxIfEnabled({
  prefersReducedMotion,
  animation,
  willChange = "transform, opacity",
}: MotionSxIfEnabledOptions) {
  if (prefersReducedMotion) return undefined;
  return { animation, willChange };
}
